const suffixLangIfNeeded = (path, currentLanguage) => {
    return currentLanguage === 'et' ? path : `${path}/${currentLanguage}`;
};
const prefixLangIfNeeded = (path, currentLanguage) => {
    return currentLanguage === 'et' || path.startsWith(`/${currentLanguage}`) ? path : `/${currentLanguage}${path}`;
};
export { suffixLangIfNeeded, prefixLangIfNeeded };
//# sourceMappingURL=NavigationHelper.js.map